import BubblyButton from '@components/button/BubblyButton'
import React, { useRef } from 'react'
import styled from 'styled-components'

const PageWrapper = styled.div`
  opacity: 1;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`
const BlendOutComponent = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  background-size: cover;
`
const HideElement = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  display: none;
  overflow: hidden;
`

const StarSystemButtonPage = ({ children }) => {
  const pageRef = useRef(null)
  const hideElementsRef = useRef(null)

  const playSound = () => {
    const planetSound = new Audio('/music/world_audio_trim.mp3')
    planetSound.volume = 0.15
    planetSound.play()
    hideElementsRef.current.style.display = 'flex'
    hideElementsRef.current.style.opacity = 1

    pageRef.current.style.display = 'none'
  }

  return (
    <PageWrapper>
      <BlendOutComponent ref={pageRef}>
        <BubblyButton onClick={playSound}>Start</BubblyButton>
      </BlendOutComponent>
      <HideElement ref={hideElementsRef}>{children}</HideElement>
    </PageWrapper>
  )
}
export default StarSystemButtonPage
